/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useMemo } from 'react';
import { Border } from '../../config-items-empty/border';
import { styleDiv, styleBorder, styleIconBackground } from './styles';
export const RainbowBorder = props => {
  const {
    children,
    shownAt
  } = props;
  const id = useMemo(() => `aiIcon_radial_${new Date().getTime()}`, []);
  if (shownAt === 'suggestions') {
    return children;
  }
  return jsx("div", {
    css: [styleDiv, styleIconBackground]
  }, jsx("svg", {
    css: styleBorder,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("rect", {
    x: "0.5",
    y: "1.5",
    width: "37",
    height: "37.5",
    rx: "1.5",
    stroke: `url(#${id})`
  }), jsx("defs", null, jsx("radialGradient", {
    id: id,
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1 1.5) rotate(44.5937) scale(49.8523)"
  }, jsx(Border, null)))), children);
};